export enum ComponentType {
  manufactured = 'manufactured',
  assembled = 'assembled',
  purchased = 'purchased',
}

export enum HeaderType {
  template = 'template',
  templateQuote = 'template_quote',
  templateJob = 'template_job',
  estimated = 'estimated',
  engineered = 'engineered',
  executed = 'executed',
}

type CostingVariableData = {
  label: string;
  value: unknown;
};

type OperationData = {
  isFinish: boolean;
  isOutsideService: boolean;
  name: string;
  notes: string | null;
  runtime: number;
  setupTime: number;
  cost: number;
  position: number;
  costingVariables: CostingVariableData[];
};

type RequiredMaterialData = {
  name: string;
  notes: string | null;
  cost: number;
  makeQty: number;
  requestedQty: number;
  unitOfMeasure: string;
  costingVariables: CostingVariableData[];
};

type ChildComponentData = {
  type: HeaderType;
  partNumber: string;
  revision: string;
  erpCode: string;
  qtyPerParent: number;
  makeQty: number;
  requestedQty: number;
};

type RootPartData = {
  partNumber: string;
  revision: string;
};

type MethodOfManufactureData = {
  type: HeaderType;
  erpCode: string;
  makeQty: number;
  requestedQty: number;
  unitPrice: number;
  totalPrice: number;
  unitCost: number;
  operations: OperationData[];
  requiredMaterials: RequiredMaterialData[];
  children: ChildComponentData[];
};

type HeaderData = {
  type: HeaderType;
  erpCode: string;
  methodsOfManufacture: MethodOfManufactureData[];
  publicNotes: string | null;
  privateNotes: string | null;
  addOns: [
    {
      isRequired: boolean;
      name: string;
      notes: string | null;
      unitPrice: number;
      useComponentQuantities: boolean;
    },
  ];
  contact: {
    email: string;
    firstName: string;
    lastName: string;
    notes: string;
    phone: string;
  } | null;
  account: {
    name: string;
    erpCode: string;
    phone: string;
    url: string;
    notes?: string | null;
  } | null;
  createdDate: number;
};

export type ImportableErpPartDetailsData = {
  erpName: string;
  area: number | null;
  filename: string | null;
  partNumber: string;
  revision: string;
  sizeX: number | null;
  sizeY: number | null;
  sizeZ: number | null;
  thickness: number | null;
  type: ComponentType;
  units: string | null;
  isRoot: boolean;
  rootPart?: RootPartData | null;
  importDate: number;
  header: HeaderData;
};

export type UseImportableErpPartDetailsParams = {
  partNumber: string;
  revision: string;
  headerErpCode: string;
  headerType: HeaderType;
};

export type ImportableErpPartDetailsQueryKey = readonly [
  'quotes',
  'importHistoricalWork',
  'importableErpPartDetails',
  UseImportableErpPartDetailsParams,
];
